import React from 'react'
import SALink from 'components/SALink'
import { CASE_STUDY_DATA } from '../../helpers/constants'
import { CaseStudy } from './styles'

type Props = {
  section: string
}

const Component = ({ section }: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const { site, text, image, award, url } = CASE_STUDY_DATA[section]
  return (
    <CaseStudy>
      <picture data-type='image'>
        <img
          width='692'
          height='462'
          itemProp='image'
          className='lazyload'
          data-src={image}
          alt='case-study'
          role='presentation'
          data-type='image'
        />
      </picture>
      <div data-type='text-section'>
        <p data-type='title'>Case Study</p>
        <p data-type='site'>{site}</p>
        <p data-type='award'>{award}</p>
        <p data-type='text'>{text}</p>
        <SALink href={url} data-type='case-study-link' target='_blank' rel='noopener noreferrer'>
          <p className='defaultTypographyCtaMedium'>Read the Case Study</p>
        </SALink>
      </div>
    </CaseStudy>
  )
}

export default Component
